<template>
  <aside
    class="bg-blue fixed z-30  inset-0  md:flex flex-col justify-between dynamic-height md:rounded-r-2xl rounded-r-none font-body text-base font-semibold text-white w-sidBar"
    :class="[isSidebarOpen ? 'block ' : 'hidden']"
  >
    <div class="flex flex-col items-center border-t border-t-white md:border-none md:mt-0 mt-[70px] h-full overflow-y-auto overflow-x-hidden no-scrollbar">
      <!-- Logo for desktop -->
      <div class="mt-[34px] hidden md:block">
        <a :href="'/' + Language + '/'">
          <img
            src="../assets/img/plexytrade-logo-white.svg"
            width="200"
          />
        </a>
      </div>

      <!-- router link  -->
      <ul class="md:mt-20 mt-6 px-3">
        <li
          v-for="(item, index) in filteredMenu"
          :class="{ 'bg-blue-300 bg-opacity-15': item.meta.active }"
          class="w-[230px] rounded-md"
          :key="index"
          :id="item.meta.T"
        >

          <router-link
            :class="[item.meta.active ? 'font-bold' : 'font-semibold']"
            class="inline-block w-[230px] p-5 text-[15px]"
            :to="'/' + Language + '/' + (item.path !== '' ? item.path : '')"
            v-if="item.path !== 'tools'"
          >
            <img
              class="h-5 w-5 inline -mt-1"
              :src="item.meta.icon"
            />
            <span class="inline-block w-6"></span>
            {{ $t(item.meta.T).tTitle() }}
          </router-link>
          <div
            v-else-if="TCDeposits < 5000"
            :class="[item.meta.active ? 'font-bold' : 'font-semibold']"
            class="cursor-pointer flex justify-between items-center w-[230px] p-5 text-[15px]"
            @click="showTradingCentralPopup()"
          >
            <div>
              <img
                class="h-5 w-5 inline -mt-1"
                :src="item.meta.icon"
              />
              <span class="inline-block w-6"></span>
              {{ $t(item.meta.T).tTitle() }}
            </div>
            <div>
              <img
                v-if="TotalTCDeposited < 5000"
                src="../../public/static/img/lock-icon.svg"
                class="h-[25px] w-[25px] mb-0"
              />
            </div>
          </div>
          <router-link
            v-else
            :class="[item.meta.active ? 'font-bold' : 'font-semibold']"
            class="inline-block w-[230px] p-5 text-[15px] font-semibold"
            :to="'/' + Language + '/' + (item.path !== '' ? item.path : '')"
          >
            <img
              class="h-5 w-5 inline -mt-1"
              :src="item.meta.icon"
            />
            <span class="inline-block w-6"></span>
            {{ $t(item.meta.T).tTitle() }}
          </router-link>
        </li>
      </ul>

      <!-- Become a partner -->
      <div
        v-if="isLive && !isIB"
        @click="becomeAnIBModal"
        class="w-full flex pt-5 justify-center rounded-md cursor-pointer"
      >
        <div class="h-[49px] bg-[#2b53a8] border border-[#426fcd] flex justify-center items-center rounded-md text-[#f8f9fd] appearance-none font-medium text-[15px] text-center w-48 ltr:float-right rtl:float-left cursor-pointer">
          {{ $t('become_a_partner').tTitle() }}
        </div>
      </div>

      <!-- social icons -->
      <div class="mt-auto mb-20 md:mb-2 py-5 flex justify-center w-full gap-1">
        <span class="inline">
          <a
            :href="facebookLinks"
            target="_blank"
          >
            <img
              class="inline-block w-[30px] h-[30px]"
              src="../assets/img/facebook.svg"
            />
          </a>
        </span>

        <span class="inline">
          <a
            :href="twitterLinks"
            target="_blank"
          >
            <img
              class="inline-block w-[30px] h-[30px]"
              src="../assets/img/twitter.svg"
            />
          </a>
        </span>

        <span class="inline">
          <a
            :href="instagramLinks"
            target="_blank"
          >
            <img
              class="inline-block w-[30px] h-[30px]"
              src="../assets/img/instagram.svg"
            />
          </a>
        </span>
      </div>
      <!-- Trading Competition Popup Desktop -->
      <div v-if="ShowCompetitionBanner">
        <transition name="banner">
          <div
            v-show="showBanner"
            class="absolute bottom-20 left-0 flex flex-col justify-center items-center bg-white mx-4 w-[228px] rounded-lg z-50 animate-pop"
          >
            <div class="w-full flex justify-end p-2">
              <button
                @click="closeCompetitionBanner"
                class="text-blue bg-gray-100 w-6 h-6 flex items-center justify-center text-base rounded-full"
              >
                ✕
              </button>
            </div>
            <img
              src="../assets/img/icons/competitions/trading-competition-dashboard-graphic.svg"
              width="160"
              height="123"
              alt=""
            >
            <div class="text-center pt-2 mb-5">
              <h2 class="text-lg text-blue pb-1">{{ $t('trading_comp') }}</h2>
              <p class="text-sm text-gray-900 font-medium pb-3">{{ $t('trading_comp_slogan') }}</p>
              <button class="py-1 bg-green rounded-md text-white appearance-none font-medium text-sm text-center w-40 cursor-pointer">
                <router-link :to="'/' + Language + '/competitions'">
                  {{ $t('enter_competition') }}
                </router-link>
              </button>
            </div>
          </div>
        </transition>

      </div>
    </div>
  </aside>
</template>

<script>
import config from '@/config';
import links from '@/config/links'
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    isSidebarOpen: {
      type: Boolean,
      required: true,
    },
    isLive: {
      type: Boolean,
      required: true,
    },
    isIB: {
      type: Boolean,
      required: true,
    },
    filteredMenu: {
      type: Array,
      required: true,
    },
    becomeAnIBModal: {
      type: Function,
      required: true,
    },
    TCDeposits: {
      type: Number,
      required: true,
    }
  },
  components: {},
  data() {
    return {
      showBanner: false,
      timeoutId: null
    }
  },
  watch: {
    ShowCompetitionBanner(newValue) {
      if (newValue) {
        // Clear any existing timeout to avoid conflicts
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => {
          this.showCompetitionBanner = true;
          this.showBanner = true;
        }, 5000); // 5-seconds delay
      } else {
        // Clear the timeout if the value is false
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
        this.showCompetitionBanner = false;
        this.showBanner = false;
      }
    },
  },
  computed: {
    twitterLinks() {
      return links.getLink('twitterLinks', 'en')
    },
    instagramLinks() {
      return links.getLink('instagramLinks', 'en')
    },
    facebookLinks() {
      return links.getLink('facebookLinks', 'en')
    },
    ShowCompetitionBanner() {
      return this.$store.getters['competition/showCompetitionBanner'](this.$route.path) && !this.logoLoaderActive && !config.eligibleCountriesTradingCompetition.includes(this.User.info.country_code) && this.isLive;
    },
    ...mapGetters({
      Language: 'language/code',
      User: 'user/all',
      UserInfo: 'user/info',
      DocCount: 'user/docCount',
      isEmailVerified: 'user/isEmailVerified',
      Menu: 'menu/all',
      logoLoaderActive: 'logoLoader/active',
      logoLoaderText: 'logoLoader/text',
      BonusConfig: 'bonusconfig/all',
      TotalTCDeposited: 'user/totalTCDeposited',
    }),
  },
  methods: {
    closeCompetitionBanner() {
      this['competition/setHasClosed'](true)
    },
    showTradingCentralPopup() {
      this.$emit('openTradingCentralPopup')
    },
    ...mapActions(['competition/setHasClosed']),
  },
}
</script>
<style scoped>
@media only screen and (max-width: 1024px) {
  .dynamic-height{
     height: 100dvh;
   }
}
</style>
